<template>
	<div class="w1200">
		<div class="association-brief-box">
		<div class="crumbs">
			<span><a href="#/">首页 ></a></span>
			<span>资讯</span>
		</div>

	</div>
		<div class="association-list clearfix">
			<div class="a-l-left fl">
				<ul>
					<ul v-on:click="divClick">
						<li>
							<a href="#/NewsList/0"  :class=" id == 0 ? 'hover' : ''">最新动态</a>
						</li>
						<li>
							<a href="#/NewsList/1" :class=" id == 1 ? 'hover' : ''">行业动态</a>
						</li>
						<li>
							<a href="#/NewsList/2" :class=" id == 2 ? 'hover' : ''">国际交流</a>
						</li>
						<li>
							<a href="#/NewsList/3" :class=" id == 3 ? 'hover' : ''">协会之友</a>
						</li>
						<li>
							<a href="#/NewsList/5" :class=" id == 5 ? 'hover' : ''">信息公示</a>
						</li>
						<li>
							<a href="#/NewsList/9" :class=" id == 9 ? 'hover' : ''">关于培训</a>
						</li>
						<li>
							<a href="#/NewsList/10" :class=" id == 10 ? 'hover' : ''">协会专栏</a>
						</li>
						<li>
							<a href="#/NewsList/11" :class=" id == 11 ? 'hover' : ''">党建工作</a>
						</li>
					</ul>
				</ul>
			</div>
			<div class="a-l-right fr">
				<div class="item" v-for="(item, index) in newListcontent">
					<div class="img" v-if="item.img!=''">
						<a :href="'#/NewSInfo/' + item.id " target="_blank"><img :src="item.img" width="160" height="100" /></a>
					</div>
					<div class="txt">
						<div class="name">
							<a :href="'#/NewSInfo/' + item.id " target="_blank">{{item.title}}</a>
						</div>
						<div class="info">

							<span class="international">{{item.group_name}}</span>
					<!--	判断颜色	<span class="association" v-if="item.group_id == 3">{{item.group_name}}</span>
							<span class="industry" v-if="item.group_id == 5">{{item.group_name}}</span>
							<span class="international" v-if="item.group_id == 9">{{item.group_name}}</span>
							<span class="association" v-if="item.group_id == 10">{{item.group_name}}</span>
							<span class="industry" v-if="item.group_id == 11">{{item.group_name}}</span>-->
							
							<i class="date">{{item.create_time | formatDate}}</i>
						</div>
					</div>
				</div>
				<!-- 分页控件 layout中的jumper布局有问题，这里没用-->
			      <el-pagination
			        class="pageView"
			        v-if="paginationShow"
			        background
			        @size-change="handleSizeChange"
			        @current-change="handleCurrentChange"
			        :current-page.sync="current"
			        :page-size="8"
			        layout="total, prev, pager, next"
			        :pager-count="11"
			        :total="total">
			      </el-pagination>
			</div>
		</div>

	</div>

</template>

<script>
	import Vue from 'vue';
	import Element from 'element-ui';
	import { formatDate } from '../assets/js/date.js';
	export default {
		inject:['reload'],//注入reload
		filters: { //格式化日期
			formatDate(time) {
				var date = new Date(time);
				return formatDate(date, 'yyyy-MM-dd hh:mm');
			}
		},
		data() {
			return {
				path:domain.apiUrl,
				newListcontent: {},
				current: 1, //当前页码
				pages: 1, //总页数
				size: 8, //每页条数
				total: 0, //总条数
				paginationShow: false,//是否显示分页
				id:0
			}
		},
		created() {
			this.newsListId();
				
		},
		methods: {
			divClick(){
				this.reload()
			},
			 
			//改变每页显示数量时调用
			handleSizeChange(val) {
				this.$nextTick(() =>
					this.newsListId(),
				)
			},
			//点击下一页和点击页码时执行
			handleCurrentChange(val) {
				
				this.newsListId();
				
			},
			//带参数接口
			newsListId() {
				var id = this.$route.params.id;
				this.id=id;
				
				this.$http.post(this.path+"index/getNewsListPage?currentPage=" + this.current + "&size=" + this.size+ "&groupId=" + id).then(function(response) {
					if(response.status === 200) {
						var data = response.body;
						this.newListcontent = data.records;
						console.log(this.newListcontent);
						this.pages = data.pages;//设置分页的总页数
          				this.total = data.total;//设置数据总条数
          				if (this.total > 1) {//总页数大于1时显示分页
				            this.paginationShow = true;
				          }
          			
					}
				})
			
			},
			/*newsListcontent() {
				this.$http.post(this.path+"index/getNewsListPage?currentPage=" + this.current + "&size=" + this.size).then(function(response) {
					if(response.status === 200) {
						var data = response.body;
						this.newListcontent = data.records;
						this.pages = data.pages;//设置分页的总页数
          				this.total = data.total;//设置数据总条数
          				if (this.total > 1) {//总页数大于1时显示分页
				            this.paginationShow = true;
				          }
					}
				})
			},
*/
		}
	}
</script>

<style>
	@import "../assets/css/list.css";
</style>


// WEBPACK FOOTER //
// src/components/NewsList.vue